import cn from 'classnames';
import moment from 'jalali-moment';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {shortenString} from '../../../../utilities/helper/shortenString';
import RateStarBadge from '../../../RateStarBadge';

const PrimaryCard = ({
  id,
  title,
  state,
  city,
  main_image,
  status,
  cardWrapperClassName,
  store,
  immediate,
  ad_type,
  discount_price,
  ad_price,
  discount_amount,
  has_discount,
  created_at,
  input_group,
  sub_brand_main_image,
  cardSize = 'md',
  onClick,
}: PrimaryCardProps) => {
  const today = new Date();
  const dateTime = moment(moment(new Date(created_at)))
    .locale('fa')
    .from(today); // "a day ago"

  return (
    <div
      className="flex w-full"
      key={id}
      // onClick={() =>
      //   navigate(
      //     `/category-card-detail/${
      //       CodeToInputGroupName[input_group.code]
      //     }/${id}`,
      //   )
      // }
      onClick={onClick}
    >
      <div
        className={cn(
          'w-[296px] px-2 py-2.5 gap-2 bg-white items-center flex rounded-[8px] shadow-sm',
          {'!h-[112px] w-[296px]': cardSize === 'md'},
          {'!h-[128px] w-full': cardSize === 'lg'},
          cardWrapperClassName,
        )}
      >
        <div
          className={cn('flex relative rounded-[8px] ', {
            '!h-[88px] !w-[88px]': cardSize === 'md',
            '!h-[112px] !w-[112px]': cardSize === 'lg',
          })}
        >
          <img
            className={cn('flex object-cover w-full h-full rounded-[8px]')}
            src={
              (main_image?.image_330 ||
                main_image?.image_128 ||
                sub_brand_main_image?.image) ??
              'https://s3.ir-thr-at1.arvanstorage.ir/shop-advertisement/empty_card_image.svg'
            }
            alt={title}
          />
        </div>
        <div className="flex flex-col flex-1 justify-between h-full">
          <div className="flex flex-col flex-1 justify-between text-md gap">
            <div className="flex flex-col">
              <div className="flex justify-between items-center">
                <span className="mb-2 min-w-0 line-clamp-2 text-ellipsis">
                  {title}
                </span>
                {ad_type === 'personal' && (
                  <span className="px-2 py-1 text-xs text-gray-800 bg-gray-200 rounded-3xl text-nowrap">
                    آگهی شخصی
                  </span>
                )}
              </div>
              {/* since multiple api are getting called for this component and backend has changed only one, we need to add fallback for when there is no ad_type */}
              {store && (!!ad_type ? ad_type === 'store' : true) && (
                <div className="flex gap-2 justify-between">
                  <div className="flex items-center text-gray-700">
                    <i className="text-lg icon-nameStore1"></i>
                    <span className="line-clamp-1">{store?.title}</span>
                  </div>
                  {store?.rate > 0 && ad_type !== 'personal' && (
                    <RateStarBadge rate={store?.rate} />
                  )}
                </div>
              )}
              {/* {lab && (
              <div className="flex gap-2">
                <i className="icon-namelaboratory"></i>
                <span>{lab?.title}</span>
              </div>
            )} */}
              {!store && state && (
                <div className="flex items-center text-sm text-gray-700">
                  <SpanIcon className="icon-nameLocation1 ml-0.5" />
                  <span>
                    {state?.name}, {city?.name}
                  </span>
                </div>
              )}
            </div>
            <div className="text-sm text-gray-700">
              {immediate && (
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-0.5">
                    <i className="icon-nameSpeaker-megaphone" />
                    <span>فوری</span>
                  </div>
                  <div>
                    {RenderPrice({
                      discount_price,
                      ad_price,
                      discount_amount,
                      has_discount,
                    })}
                  </div>
                </div>
              )}
              {status === 'rejected' && (
                <div className="flex justify-between">
                  <span className="text-red-200">رد شده </span>
                  <div className="flex gap-2">
                    <span className="text-green-300">رفع نواقص</span>
                    <span className="text-red-200">حذف</span>
                  </div>
                </div>
              )}
              {status === 'pending' && (
                <div className="flex justify-between w-full">
                  <span className="text-red-200">در انتظار تایید</span>
                  {RenderPrice({
                    discount_price,
                    ad_price,
                    discount_amount,
                    has_discount,
                  })}
                </div>
              )}
              {status === 'published' && !immediate && (
                <div className="flex flex-1 justify-between items-end">
                  <span className="flex text-xs">{dateTime}</span>
                  {RenderPrice({
                    discount_price,
                    ad_price,
                    discount_amount,
                    has_discount,
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimaryCard;
const RenderPrice = ({
  discount_price,
  ad_price,
  discount_amount,
  has_discount,
}: IPriceProps) => {
  const originalPrice = Number(ad_price);
  const discountedPrice = Number(discount_price);
  const discountPercent = Number(discount_amount);

  const isValidPrice = (price: number) => Number.isFinite(price) && price > 0;

  const hasValidOriginalPrice = isValidPrice(originalPrice);

  const showDiscount =
    has_discount &&
    hasValidOriginalPrice &&
    isValidPrice(discountedPrice) &&
    discountedPrice < originalPrice &&
    Number.isFinite(discountPercent) &&
    discountPercent > 0;

  if (!hasValidOriginalPrice) {
    return null;
  }

  const finalPrice = showDiscount ? discountedPrice : originalPrice;

  const formatPrice = (price: number) => Math.round(price).toLocaleString();

  return (
    <div className="flex items-center text-xs font-medium text-gray-700">
      <div className="flex flex-col text-left">
        {showDiscount && (
          <span className="flex gap-1 items-center text-sm line-through text-neutral-600">
            <span className="text-sm">{formatPrice(originalPrice)}</span>

            <span className="text-xs">تومان</span>
          </span>
        )}

        <div className="flex gap-1 items-center">
          {showDiscount && (
            <div className="flex justify-center items-center px-2 h-5 text-white bg-red-500 rounded min-w-6">
              {discountPercent}%
            </div>
          )}

          <span className="flex gap-1 items-center text-sm text-neutral-600">
            <span>{formatPrice(finalPrice)}</span>

            <span className="text-xs">تومان</span>
          </span>
        </div>
      </div>
    </div>
  );
};
